var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['sub-banner', _vm.bannerType]},[_c('div',{staticClass:"banner-content"},[_c('i',{class:_vm.bannerIcon}),_c('span',[_vm._v(_vm._s(_vm.bannerMessage))])]),(_vm.dismissable)?_c('button',{staticClass:"banner-close",on:{"click":_vm.dismiss}},[_vm._v("×")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }